module.exports = "\n<!--\n<nav class=\"navbar navbar-fixed-bottom navbar-light bg-faded\">\n  <a class=\"navbar-brand\" href=\"#\">Fixed bottom</a>\n</nav>\n-->"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/fulfillment.release/src/app/layout/footer/footer.component.html
// module id = ../../../../../src/app/layout/footer/footer.component.html
// module chunks = 0